import { render, staticRenderFns } from "./BillDeleteRequest.vue?vue&type=template&id=834c24b4"
import script from "./BillDeleteRequest.vue?vue&type=script&lang=js"
export * from "./BillDeleteRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports